import React, { useContext, useState, useEffect } from "react";
import { AuthContext } from "../../../context/AuthContext";
import { useLocation, useNavigate } from "react-router-dom";
import Questionary from "../../Questionaries/Questionary/Questionary";
import Container from "../../../ui/Container/Container";
import { updatePatientsInfo, getPatient } from "../../../db/users";

function Abandon() {
  const authCtx = useContext(AuthContext);
  const location = useLocation();
  const navigate = useNavigate();
  const patientId = location.state.patientId;
  const [patient, setPatient] = useState();
  const [showQuestionary, setShowQuestionary] = useState(false);
  const [isFetching, setIsFetching] = useState(true);

  useEffect(() => {
    async function fetchPatient() {
      setIsFetching(true);
      const response = await getPatient(
        authCtx.userId,
        patientId,
        authCtx.token
      );
      if (!response.data) {
        setIsFetching(false);
      } else {
        setPatient(response.data);
        setShowQuestionary(!response.data.isPatientAbandon);
        setIsFetching(false);
      }
    }
    try {
      fetchPatient();
    } catch (error) {
      console.log(error);
    }
  }, [patientId]);

  async function saveQuestionary(userAnswers) {
    const path = `${patientId}/questionaries/patient_abandon`;
    await updatePatientsInfo(
      patientId,
      authCtx.userId,
      {
        isPatientAbandon: true,
      },
      authCtx.token
    );
    await updatePatientsInfo(
      path,
      authCtx.userId,
      {
        answers: userAnswers,
      },
      authCtx.token
    );
    alert("Cuestionario registrado con éxito.");
    navigate("/patientInfo", { state: { patientKey: patientId } });
  }

  if (isFetching) {
    return <p>Cargando...</p>;
  }

  if (showQuestionary) {
    return (
      <Container
        title="Cuestionario"
        backNavigation="/patientInfo"
        route={{ patientKey: patientId }}
      >
        <Questionary
          questionaryId={"patient_abandon"}
          token={authCtx.token}
          onSaveQuestionary={saveQuestionary}
        />
      </Container>
    );
  } else {
    navigate("/showResults", {
      state: {
        patient: patient,
        key: "patient_abandon",
        navigateTo: "/patientInfo",
        patientKey: patientId,
      },
    });
  }
}

export default Abandon;
